import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect, useRef } from 'react';
import DialogFobConnectionComponent from '../DialogConnectionComponents/DialogFobConnectionComponent';
import { loadingFobDataComponent, loadingRankComponentDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { UpdateFob, UpdateFobName, UpdateFobRankNode } from '../../../UpdateData/UpdateCommunications';
import DialogFobFotoEditing from '../DialogFoto/DialogFobFotoEditing';

import { UpdateFobEtherComponents, UpdateFobKtvComponents, UpdateFobPonComponents, UpdateStatusComponents } from '../../../UpdateData/UpdateStatusComponent';
import { FOB } from '../../../Constants/ConstantsOptics';

const FobNodeCantonEditingDialog = ({ open, onClose, content, user, cantonFobRefresh, cantonRefresh}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState('');
  const [statusChange, setStatusChange] = useState(false);
  const [openModalConnection, setOpenModalConnection] = useState(false);
  const [fobData, setFobData] = useState([]);
  const [fobId, setFobId] = useState("");
  const [rankComponentData, setRankComponentData] = useState([]);
  const [openModalFoto, setOpenModalFoto] = useState(false);
  const [statusPon, setStatusPon] = useState(false); 
  const [statusKtv, setStatusKtv] = useState(false); 
  const [statusEther, setStatusEther] = useState(false); 
  const [fobRankId, setFobRankId] = useState("");

  useEffect(() => {
    if (content && content.description) {
      setTextComment(content.description);
    }
  }, [content]);

  const openModalFotoFile = () => {
    setOpenModalFoto(true);
  }; 

  useEffect(() => {
    setStatusPon(content.pon === 1);
    setStatusKtv(content.ktv === 1);
    setStatusEther(content.ether === 1);
  }, [content.activity, content.pon, content.ktv, content.ether]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [fobData, rankComponentData] = await Promise.all([
          loadingFobDataComponent(),
          loadingRankComponentDataComponent(),
        ]);
        setFobData(fobData);
        setRankComponentData(rankComponentData);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

  
  const handleCloseDialogs = () => {
    cantonRefresh();
    onClose();
  };

  

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };
 
  const updateFob = () => {
    if (statusChange) {
      UpdateFob(content.id, textComment, showSnackbar,content.authorId, cantonFobRefresh);
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };

  const handleChangeFobSelect = (event) => {
    const selectedFob = event.target.value;
    if (selectedFob === "") {
      setFobId("");
    } else {
      const selectedFob2 = fobData.find(fob => 
        `${fob.id}` === selectedFob
      );
      if (selectedFob2) {
        setFobId(selectedFob2.id);
      }
    }
  };

  const updateFobName = () => {
  
    if (fobId === "") {
      showSnackbar('Нет нужды в записи, Fob без изменений!', 'snackbarOk');
    } else {
      UpdateFobName(content.id, fobId, showSnackbar,content.authorId, cantonFobRefresh );
    } 
  };

  const handlePonCheckboxChange = () => {
    setStatusPon(!statusPon);   
    if(!statusPon){
      UpdateFobPonComponents(content.id, 1, showSnackbar, null, content.authorId);
    }else{
      UpdateFobPonComponents(content.id, 0, showSnackbar, null, content.authorId)
    }
    
  };

  const handleKtvCheckboxChange = () => {
    setStatusKtv(!statusKtv);   
    if(!statusKtv){
      UpdateFobKtvComponents(content.id, 1, showSnackbar, cantonFobRefresh, content.authorId);
    }else{
      UpdateFobKtvComponents(content.id, 0, showSnackbar, cantonFobRefresh, content.authorId)
    } 
  };

  const handleEtherCheckboxChange = () => {
    setStatusEther(!statusEther);   
    if(!statusEther){
      UpdateFobEtherComponents(content.id, 1, showSnackbar, cantonFobRefresh, content.authorId);
    }else{
      UpdateFobEtherComponents(content.id, 0, showSnackbar, cantonFobRefresh, content.authorId)
    }
  };

  const handleChangeFobRankSelect = (event) => {
    const selectedFobRank = event.target.value;
    if (selectedFobRank === "") {
      setFobRankId("");
    } else {
      const selectedFobRank2 = rankComponentData.find(fobRank => 
        `${fobRank.id}` === selectedFobRank
      );
      if (selectedFobRank2) {
        setFobRankId(selectedFobRank2.id);
      }
    }
  };

   const updateFobRank = () => {    
      if (fobRankId === "") {
        showSnackbar('Нет нужды в записи, ранг без изменений!', 'snackbarOk');
      } else {
        UpdateFobRankNode(content.id, fobRankId, showSnackbar, cantonFobRefresh);
      } 
    };

     const deleteFob = () => {
          UpdateStatusComponents(FOB, content.id, showSnackbar, user, cantonRefresh,  handleCloseDialogs);
      }; 

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      {content.rankComponentId === 1 || content.rankComponentId === 2 ? (
           <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./fob_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование фоба</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{content.canton} {content.region} {content.area}</span> </label>
      
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Фоб: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangeFobSelect(event);
        }} >
        <option value="">{content.fobName}</option>
        {fobData.map(fob => (
          <option key={fob.id} value={fob.id}>{fob.name}</option>
        ))}
      </select>
      <button onClick={updateFobName} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Мax ранг линка: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangeFobRankSelect(event);
        }} >
        <option value="">{content.rankComponentName}</option>
        {rankComponentData.map(rank => (
          <option key={rank.id} value={rank.id}>{rank.name}</option>
        ))}
      </select>
      <button onClick={updateFobRank} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>
    
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Признак:</label>

<label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>PON:</label>
    <input
      type="checkbox"
      checked={statusPon}
      onChange={handlePonCheckboxChange}
      style={{ marginLeft: '10px' }}
    />      

  <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>KTV:</label>
    <input
      type="checkbox"
      checked={statusKtv}
      onChange={handleKtvCheckboxChange}
      style={{ marginLeft: '10px' }}
    />      

  <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>Ethernet:</label>
    <input
      type="checkbox"
      checked={statusEther}
      onChange={handleEtherCheckboxChange}
      style={{ marginLeft: '10px' }}
    />      

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{content.authorId}</span></label>
    
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />

      <br/>
      <button onClick={updateFob} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>

      {/* <hr className='horizontalLineDialog'/>
      <button  class='buttonIsCoupFobDialog' onClick={openModalConnectionComponents}> Закрепить фоб</button> */}
      <hr className='horizontalLineDialog'/>
      <button  class='buttonIsEditDialog' onClick={openModalFotoFile}> Редактирование файлов</button>
      <hr className='horizontalLineDialog'/>
      <button 
          className="buttonIsDeleteModal" 
          onClick={deleteFob} 
          style={{ fontSize: "14px", width: "60px", padding: "2px" }}
        >
          Удалить
        </button>

        <span 
          style={{
            marginLeft: "5px",
            fontSize: "12px",
            color: "#bebebe",
            textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
          }}
        >
       Возможность восстановления 24 ч.
      </span>

      <hr className='horizontalLineDialog'/>

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>


       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

        {/* Modal Foto*/}
        <DialogFobFotoEditing
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}
          user={content.authorId}     
      />   

      <DialogFobConnectionComponent
          id={content.id}
          open={openModalConnection}
          onClose={() => setOpenModalConnection(false)}
          user={user}
      />
    </Dialog>
  );
}

export default FobNodeCantonEditingDialog;